import { RunParameter } from "../../../../api";
import { IParameterRenderer, RenderParamLabSettingsProps } from "../ParameterRendererAbstracts";
import { Select } from "@/components/bp/bp-ui";
import { CaseRunCalculateModel, CaseRunClient, CaseRunCreateModel, CaseRunCreateModelBase, MaxLrCaseRunCreateModelBase } from "@app/api2/api";
import { ICreateRenderer } from "../CaseRunCreate";
import { ReviewMaxLr } from "../ReviewMaxLr";
export class NonContributorAnalysisHandler implements IParameterRenderer, ICreateRenderer<CaseRunCreateModelBase, any> {
    caseRunClient = new CaseRunClient();

    save(props: { labId: number, caseId: number, model: CaseRunCreateModelBase }) {
        return new CaseRunClient().createNonContrAnalysis(props.labId, props.caseId, props.model)
    }

    createBlankModel(props: { labId: number, caseId: number, runType: string, evidenceId?: number, ednaTestId?: number }): Promise<CaseRunCreateModelBase> {
        return this.caseRunClient.new(props.labId, props.caseId, props.runType, props.evidenceId, props.ednaTestId ?? null)
    }

    renderReview(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any) {
        return <ReviewMaxLr model={model as CaseRunCreateModel} onComplete={onComplete} router={router} />
    }

    renderInformation(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any, rangeOfContributors: boolean) {
        return <div>no info</div>
    }

    runType: string = "nc_analysis";

    canHandle(runType: string): boolean {
        return runType == this.runType;
    }

    applyInformationValuesToModel = (model1: CaseRunCreateModelBase, values: any) => {
        // model1 = fillWithValues(model1, values, false)

        return model1;
    };

    propsComplete = (model: CaseRunCreateModelBase): void => {
        model.parameters = model.parameters.sort((a, b) => a.order < b.order ? -1 : 1)
    };

    canRenderParameter(parameterName: string): boolean {
        return parameterName == "refSampleId";
    }

    renderParameterEditor(model: CaseRunCreateModelBase | CaseRunCalculateModel, p: RunParameter, values, onChange, errors, setFieldValue): JSX.Element {
        let model_ = model as MaxLrCaseRunCreateModelBase
        let options = model_.hp.filter(p => !model_.hd.some(h => h.id == p.id)).map((m, idx) => { return { key: m.id, text: m.name, value: m.id }; })

        return (<Select name={p.parameter} options={options} onChange={(ev, d) => onChange(p, d.value)} />);
    }

    renderParameterView({model, p}): JSX.Element {
        let options = model.hp.filter(p => !model.hd.some(h => h.id == p.id)).map((m, idx) => { return { key: m.id, text: m.name, value: m.id }; })
        let selected = options.find(x => x.value == parseInt(p.value));
        return (<span>{selected.text}</span>);
    }

    renderParameterLabSettings?(p: RenderParamLabSettingsProps): JSX.Element {
        return null;
    }


}
